var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderItem1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 218,
    viewBox: "0 0 218 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.047 0.453372L107.389 0.453369L73.4388 36.2386L36.6927 72.9847L0.915043 106.928L0.915039 110.6L36.6927 144.543L73.4388 181.289L107.389 217.074H111.047L144.997 181.289L181.743 144.543L217.51 110.61V106.917L181.743 72.9847L144.997 36.2386L111.047 0.453372ZM32.6996 107.472V110.056L57.9808 134.041L83.9409 160.001L107.921 185.277H110.515L134.495 160.001L160.455 134.041L185.736 110.056V107.472L160.455 83.4869L134.495 57.5268L110.522 32.2587L107.913 32.2586L83.9409 57.5268L57.9808 83.4868L32.6996 107.472Z",
    fill: "url(#paint0_radial_96_1451)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_96_1451",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.218 108.764) rotate(90) scale(110.139)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderItem1);
export default __webpack_public_path__ + "static/media/header-item-1.5f1e19cb996e4fc3c091b9e20790ef71.svg";
export { ForwardRef as ReactComponent };